import React from 'react'
import SliderList from './SliderList'

export default function SliderCont( ) {

    const arrayDeProgramas = [
        {
            "name": "Foja Cero",
            "radio": "La Red AM 910 - Sábados de 8 a 10hs",
            "conductor": "Con Facundo Pastor",
            "description": 'Entrevistas con los principales protagonistas de la información, editoriales con opinión y el agregado de su estilo dinámico y la veracidad periodística, permiten abordar de manera más profunda los temas de la semana. ',
            "img": "https://pbs.twimg.com/media/FgKya74WQAE8WZ5.jpg"
        },
        {
            "name": "En la luna de Milenium",
            "radio": "FM Milenium FM 1067 - Martes 21hs",
            "conductor": "Con Mariano Yezze",
            "description": "Un programa de fin del día, basado en las buenas noticias, con entrevistas amenas y la mejor música de Milenium.",
            "img": "https://firebasestorage.googleapis.com/v0/b/autoprecios-f936b.appspot.com/o/foja%2F110831749_3101284176573472_2540781089918984350_n.jpg?alt=media&token=087176bc-0e7a-4d0f-8661-965a263c3ec8"
        },
        {
            "name": "Web Economía SOS",
            "radio": "La Red AM 910 - Sábados desde 8hs",
            "conductor": "Con Virginia Porcella",
            "description": "Bajamos a tierra las noticias y los temas de la macroeconomía para hacer sencilla la explicación de su impacto en la vida cotidiana.",
            "img": "https://firebasestorage.googleapis.com/v0/b/revista1986-c6922.appspot.com/o/Foja%2Fvirginia-7T4SZ4MADNETVGALVBMUG3KLSY.jpg?alt=media&token=c06b14aa-66dc-465b-8ccf-3aa6f0d08eac"
        },
        {
            "name": "De haberlo sabido",
            "radio": "La 750 AM 750 - Sábados de 11 a 13hs",
            "conductor": "Con Claudio Zlotnik y David Cufré",
            "description": "Un programa con una mirada distinta de la economía y la actualidad de nuestro país.",
            "img": "https://resizer.glanacion.com/resizer/v2/de-haberlo-sabido-el-ciclo-conducido-por-claudio-ZXRTD4RDAVHB7LIWB4BIUNDDBI.jpeg?auth=026658e9ec0dc0208f638cfd4440f27e2f60fb3a3f7b38296a642ba34955de78&width=768&height=576&quality=70&smart=true"
        },
        {
            "name": "Las cosas claras",
            "radio": "La Red AM 910 - Domingos de 8 a 10hs",
            "conductor": "Con Clara Mariño",
            "description": "Arrancá los domingos escuchando toda la información con las voces y definiciones de los protagonistas junto a Clara Mariño y su equipo.",
            "img": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTqarbFRtezUYeBnQFgrIK_GHnrG3D5IDWGeQ&s"
        },
        {
            "name": "Toma y Daca",
            "radio": "La 750 AM 750 - Sábados de 9 a 11hs",
            "conductor": "Con Mariano Martin",
            "description": "Siempre con la misma premisa: informar de una manera llana, para tratar de anticipar lo que vendrá. ",
            "img": "https://imgsvr.radiocut.site/get/thumb/600/600/shows_logos/23/6f/236f6810-fefb-433d-8706-fb9843f19ee0.jpg"
        }
        ,
        {
            "name": "15 Comunas",
            "radio": "Sitio web",
            "conductor": "www.15comunas.com.ar",
            "description": "Es un sitio de noticias sobre la Ciudad de Buenos Aires. Una experiencia de participación ciudadana periodística. Política, economía y cultura de una Ciudad en permanente movimiento.",
            "img": "https://firebasestorage.googleapis.com/v0/b/autoprecios-f936b.appspot.com/o/foja%2F15comunas.png?alt=media&token=d25f7b73-1c59-4da4-aac4-e99d6891a558"
        }
    ]
    
  return (
    <>
    <SliderList array={arrayDeProgramas} />
    </>
  )
}
